export default "__VITE_ASSET__nOTSWKfh__"